import { useRef } from 'react'

/** Custom hook for horizontal dragging behavior */
export const useHorizontalDragScroll = <T extends HTMLElement>(
  ref: React.RefObject<T>
) => {
  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollLeftStart = useRef(0)

  const onMouseDown = (event: React.MouseEvent) => {
    if (ref.current) {
      isDragging.current = true
      startX.current = event.pageX - ref.current.offsetLeft
      scrollLeftStart.current = ref.current.scrollLeft
      ref.current.style.cursor = 'grabbing'
    }
  }

  const onMouseMove = (event: React.MouseEvent) => {
    if (!isDragging.current || !ref.current) return
    event.preventDefault()
    const x = event.pageX - ref.current.offsetLeft
    const walk = x - startX.current
    ref.current.scrollLeft = scrollLeftStart.current - walk
  }

  const onMouseUp = () => {
    isDragging.current = false
    if (ref.current) {
      ref.current.style.cursor = 'grab'
    }
  }

  return { onMouseDown, onMouseMove, onMouseUp }
}
